import { useMemo } from 'react'

import { useGaList } from 'utils/api/useGaList'
import { useGscList } from 'utils/api/useGscList'

export const useGaGscProperties = (companyId: string) => {
  const {
    data: gscList,
    isLoading: isLoadingGsc,
    error: gscError,
  } = useGscList(companyId)
  const {
    data: gaList,
    isLoading: isLoadingGa,
    error: gaError,
  } = useGaList(companyId)

  const gscOptions = useMemo(() => {
    return (
      gscList?.data?.map(item => {
        const domain = item.uri.replace('sc-domain:', '')
        return {
          label: { header: domain },
          value: item.uri,
        }
      }) ?? []
    )
  }, [gscList?.data])

  const gaOptions = useMemo(() => {
    return (
      gaList?.data?.map((item, index) => {
        return {
          label: {
            header: item.uri,
            subHeader: item.name.replace('properties/', ''),
          },
          value: `${item.name}_${item.uri}_${index}`,
        }
      }) ?? []
    )
  }, [gaList?.data])

  return {
    gscOptions,
    gaOptions,
    isLoading: isLoadingGa || isLoadingGsc,
    gscError,
    gaError,
  }
}
